var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeekbarPause(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.58 53.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb5757;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause-seekbar"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.79,
    cy: 26.79,
    r: 26.79
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2-2",
    "data-name": "Layer 2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pause",
    className: "cls-2",
    d: "M35.59,33.69V19.89a1.9,1.9,0,0,0-1.9-1.9H30a1.9,1.9,0,0,0-1.9,1.9h0v13.7a1.9,1.9,0,0,0,1.9,1.9h3.7a1.81,1.81,0,0,0,1.9-1.8Zm-11.9,1.9h-3.8a1.9,1.9,0,0,1-1.9-1.9h0V19.89a1.9,1.9,0,0,1,1.9-1.9h3.7a1.9,1.9,0,0,1,1.9,1.9h0v13.7a1.84,1.84,0,0,1-1.8,2Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekbarPause);
export default __webpack_public_path__ + "static/media/seekbar-pause.dc65d90fec7cb0fe7f531f77bf5b2366.svg";
export { ForwardRef as ReactComponent };